import { render, staticRenderFns } from "./cms-block-container.vue?vue&type=template&id=7b984e50&scoped=true"
import script from "./cms-block-container.vue?vue&type=script&lang=js"
export * from "./cms-block-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b984e50",
  null
  
)

export default component.exports